var pug = require("!../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Ccampaign-landing-template campaign=\"currentCampaign\" state-params=\"stateParams\"\u003E\u003C\u002Fcampaign-landing-template\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/states/campaignLanding/campaignLanding.jade
// module id = 702
// module chunks = 1